class AccordionAnchors {
  constructor() {

    var anchor = window.location.hash;
    $(anchor).collapse('show');
  }
}

document.addEventListener('DOMContentLoaded', () => {
  new AccordionAnchors();
})
